import React, { useCallback } from 'react'
import Picker from '@emoji-mart/react'
import { Box, Stack } from '@ui'
import { useCardOpenerContext } from 'ui/components/Overlay/CardOpenerContext'
import { ButtonSpinner } from 'ui/components/Spinner/ButtonSpinner'
import { vars } from 'ui/styles/vars.css'

import { emojiPickerClassName } from './EmojiPickerContainer.css'
import { EmojiPickerSelection, useEmojiData } from './useEmojiData'

export const EmojiPickerContainer = (props: {
    onEmojiSelect: (data: EmojiPickerSelection) => void
}) => {
    const { closeCard } = useCardOpenerContext()
    const { data, loading, error } = useEmojiData()

    const onEmojiSelect = useCallback(
        (data: EmojiPickerSelection) => {
            closeCard()
            props.onEmojiSelect(data)
        },
        [closeCard, props],
    )

    if (loading) {
        return (
            <Box paddingY className={emojiPickerClassName} insetX="xs">
                <Stack centerContent height="250">
                    <ButtonSpinner />
                </Stack>
            </Box>
        )
    }

    if (error || !data) {
        return (
            <Box paddingY className={emojiPickerClassName} insetX="xs">
                <Stack centerContent height="250">
                    <Box color="error">Failed to load emoji data</Box>
                </Stack>
            </Box>
        )
    }

    return (
        <Box paddingY className={emojiPickerClassName} insetX="xs">
            <Box borderRadius="md" boxShadow="dropdown">
                <Picker
                    autoFocus
                    data={data}
                    previewPosition="none"
                    theme="dark"
                    emojiButtonColors={[vars.color.background.level3]}
                    onEmojiSelect={onEmojiSelect}
                />
            </Box>
        </Box>
    )
}
